import * as types from '../costants/ActionTypes'
import {SHIPPING_COST_URL, SHIPPING_URL} from "../costants/Urls";
import axios from 'axios'
import {setCartData} from "./nCartAppActions";


export const setShippingData = (data) => ({
  type: types.SET_SHIPPING_DATA,
  data
});

export const setPickupValue = data => ({
  type: types.SET_PICKUP_VALUE,
  data
});

export const setShippingValue = data =>({
  type: types.SET_SHIPPING_VALUE,
  data
})

export const setShippingCost = (data) => ({
  type: types.SET_SHIPPING_COST,
  data
});

export const setShippingError = () => ({
  type: types.SET_SHIPPING_ERROR
});

export const setShippingStatus = status => ({
  type: types.SET_SHIPPING_STATUS,
  status
});

const post_config = {
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken',
        withCredentials: true
      }


export const getShippingCost = (value, changed) =>  (dispatch, getState) => {

    dispatch(setShippingStatus('FETCHING'));

    let data_for_send = {
        method: 'shipping',
        value: value
    }

    if(!changed){

        const cstate = getState();

        data_for_send.delivery = cstate.nshipping.variants.shipping.delivery
        data_for_send.variant = cstate.nshipping.variants.shipping.variant
    }

    axios.post(SHIPPING_COST_URL, data_for_send, post_config)
      .then(res => {

        if (res.status === 200 || res.status === 201){

            dispatch(setShippingCost(res.data));

                if(res.data.calculated){

                  dispatch(setShippingToCart());

                }else{

                    dispatch(setShippingError());

                }

        }else{
            dispatch(setShippingError());
        }

      })
      .catch(err => {
        console.log(err);
        dispatch(setShippingError());

      });

};


export const setShippingToCart = () =>  (dispatch, getState) => {

    const current_state = getState();
    dispatch(setShippingStatus('FETCHING'));

    const current_method_name = current_state.nshipping.method;
    const current_method_obj = current_state.nshipping.variants[current_method_name];

    const data_for_cart = {
        method: current_method_name,
        value: current_method_obj.value,
        variant: current_method_obj.variant,
        delivery: current_method_obj.delivery || '',
        map: current_method_obj.map || {}
    };

    axios.post(SHIPPING_URL, data_for_cart, post_config)
      .then(res => {

        if (res.status === 200 || res.status === 201){

            dispatch(setShippingData(res.data.shipping));
            dispatch(setCartData(res.data.cart));
            dispatch(setShippingStatus('READY'));

        }else{

            dispatch(setShippingError());
        }

      })
      .catch(err => {

        dispatch(setShippingError());
      });

};
